/*eslint react-hooks/exhaustive-deps: "off"*/
/*eslint no-unused-vars: "off"*/
import React, { useEffect} from "react";
import useMapProps from "./useMapProps";
import {MapPropsProvider} from "./MapPropsContext";
import MapBase from "./MapBase";
import WidgetCellularDensity from "./widgets/WidgetCellularDensity";
import WidgetContainer from "./widgets/WidgetContainer";
import WidgetGeocoding from "./widgets/WidgetGeocoding";
import WidgetToolbar from "./widgets/WidgetToolbar";
import WidgetLegend from "./widgets/WidgetLegend";


const INITIAL_VIEW_STATE = {
  zoom: 8,
};

const MapCellularStats = () => {
  const mapProps = useMapProps({
    INITIAL_WIDGET_STATE: {
      code_density: "SK",
    },
    INITIAL_VIEW_STATE
  });

  const {
    widgetState,
    updateMapLayerNames,
  } = mapProps;

  const cellularCodeList = ["SK", "KT", "LG", "2G", "3G", "4G", "5G"];

  useEffect(() => {
    const {
      code_density
    } = widgetState;

    for (let code of cellularCodeList) {
      const layerName = 'PMS_' + code;
      const isEqualCode = code_density === code;
      updateMapLayerNames(layerName, isEqualCode);
    }
  }, [widgetState]);

  return (
    <MapPropsProvider value={mapProps}>
      <MapBase isIgnoreCenterChangeEvent={true} isHideControlOnClustering={true}>
        <WidgetContainer>
          <div>
            <WidgetGeocoding zoom={16}/>
            <WidgetCellularDensity/>
          </div>
        </WidgetContainer>
        <WidgetLegend />
      </MapBase>
      <WidgetToolbar />
    </MapPropsProvider>
  );
};


export default MapCellularStats;
